import React from "react";
import { COUNTRIES } from "./countries";
import { useLang } from "../i18n";

export default function CountrySelect({ value, onChange, testid, required = false }) {
  const { lang } = useLang();
  return (
    <select className="ec-input" value={value || ""} onChange={onChange} required={required} data-testid={testid}>
      <option value="">—</option>
      {COUNTRIES.map(([es, en]) => (
        <option key={en} value={lang === "en" ? en : es}>{lang === "en" ? en : es}</option>
      ))}
    </select>
  );
}
